import * as React from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

export type TestEmailDialogFormProps = {
  open: boolean;
  onClose: () => void;
  onSend?: (email: string) => Promise<void> | void;
};

const TestEmailDialogForm = ({open, onClose, onSend}: TestEmailDialogFormProps) => {
  const [email, setEmail] = React.useState("");
  const [touched, setTouched] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);

  const emailError =
    touched && (email.trim() === "" || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
      ? "Please enter a valid email"
      : "";

  const canSend = emailError === "" && email.trim() !== "" && !submitting;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setTouched(true);
    if (!canSend) return;

    try {
      setSubmitting(true);
      await onSend?.(email.trim());
      // reset & close
      // setEmail("");
      setTouched(false);
      onClose();
    } finally {
      setSubmitting(false);
    }
  };


  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs" aria-labelledby="email-dialog-title">
      <DialogTitle id="email-dialog-title">Send Email</DialogTitle>
      <Box component="form" onSubmit={handleSubmit} noValidate>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Email"
            type="email"
            fullWidth
            required
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onBlur={() => setTouched(true)}
            error={Boolean(emailError)}
            helperText={emailError || "Enter the recipient’s email address"}
            inputProps={{inputMode: "email", "aria-label": "email"}}
          />
        </DialogContent>
        <DialogActions sx={{px: 3, pb: 2}}>
          <Button onClick={onClose} disabled={submitting}>Cancel</Button>
          <Button
            type="submit"
            variant="contained"
            disabled={!canSend}
            endIcon={submitting ? <CircularProgress size={18}/> : null}
          >
            {submitting ? "Sending..." : "Send"}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
export default TestEmailDialogForm;